import {Component, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ActivatedRoute, Event, NavigationEnd, Router, RouterLink, RouterLinkActive} from '@angular/router';
import {distinctUntilChanged, filter} from 'rxjs';

interface IBreadCrumb {
  label: string;
  url: string;
}

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrl: './breadcrumb.component.scss',
  imports: [
    CommonModule, RouterLink, RouterLinkActive
  ],
  standalone: true,
})

export class BreadcrumbComponent implements OnInit {
  public breadcrumbs: IBreadCrumb[] = [];

  constructor(
    private router: Router,
  ) {
    let routerWithoutParams = this.router.url.replace(/\?.*/, "");
    this.breadcrumbs = this.buildBreadcrumbs(routerWithoutParams);
  }

  ngOnInit(): void {
    this.router.events
      .pipe(
        filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd),
        distinctUntilChanged(),
      )
      .subscribe(() => {
        let routerWithoutParams = this.router.url.replace(/\?.*/, "");
        this.breadcrumbs = this.buildBreadcrumbs(routerWithoutParams);
      })
  }

  buildBreadcrumbs(url: string): IBreadCrumb[] {
    const breadcrumbs: IBreadCrumb[] = [];
    let currentUrl = '';

    const urlSegments = url.split('/').filter(segment => segment);

    urlSegments.forEach(segment => {
      const isIdSegment = this.isId(segment);
      // Ignorer les id dans le fil d'arianne
      if (!isIdSegment) {
        currentUrl += `/${segment}`;
        let formattedLabel = this.formatSegment(segment);

        // Modifier les noms des urls spécifiques
        if (segment === 'liste-procedures') {
          formattedLabel = "Procédures d'exploitation";
        } else if (segment === 'modifier-procedure') {
          formattedLabel = "Modifier une procédure";
        } else if (segment.toLowerCase().includes('readonly')) {
          formattedLabel = "Consultation";
        } else if ("liste-procedures-archivees") {
          formattedLabel = "Procédures archivées";
        }

        breadcrumbs.push({ label: formattedLabel, url: currentUrl });
      }
    });

    return breadcrumbs;
  }

  formatSegment(segment: string): string {
    return segment.replace(/-/g, ' ').replace(/\b\w/g, char => char.toUpperCase());
  }

  isId(segment: string): boolean {
    return /^[a-f0-9]{24}$/.test(segment) || /^\d+$/.test(segment);
  }
}
